import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';

import { HeaderComponent } from './header.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    
    MatButtonModule,
    MatDividerModule
  ],
  exports: [
    HeaderComponent
  ],
  providers: [
  ],
  declarations: [
    HeaderComponent
  ]
})
export class HeaderModule { }
